<template>
  <div class="footer">
    <div class="footer__wrapper">
      <div class="footer__content">
        <div class="footer__content-left">
          <ul class="footer__content-list">
            <li class="footer__content-item">
              <a href="https://inflowbusiness.ru/#Advantages">Преимущества</a>
            </li>
            <li class="footer__content-item">
              <a href="https://inflowbusiness.ru/#Integrations">Интеграции</a>
            </li>
            <li class="footer__content-item">
              <a href="https://inflowbusiness.ru/#Reviews">Отзывы</a>
            </li>
            <li class="footer__content-item">
              <a href="https://inflowbusiness.ru/#Possibilities">Возможности</a>
            </li>
            <li class="footer__content-item">
              <a href="https://inflowbusiness.ru/#Successfulcases">Успешные кейсы</a>
            </li>
          </ul>
          <a v-if="!mainStore.isMobile" href="https://softwarecenter.ru/" target="_blank" class="footer__content-info">
            <p>Разработчик<br><b>"Центр Программного Обеспечения"</b></p>
            <p><b>"Лучший разработчик программного обеспечения в России по версии Сбера"</b></p>
          </a>
        </div>
        <div>
          <button :disabled="isLoading" class="footer__clear" @click="clearHistory">
            Очистить историю
          </button>
        </div>
        <div class="footer__content-right">
          <div class="footer__content-name">
            Контакты
          </div>
          <a href="tel:88002017211" class="footer__content-phone">
            <SvgIcon icon="phone" />
            <span>8 (800) 201 7211</span>
          </a>
          <!--          <a href="tel:88002017211" class="footer__content-phone"> -->
          <!--            <SvgIcon icon="phone" /> -->
          <!--            <span>8 (800) 201 7211</span> -->
          <!--          </a> -->
          <div class="footer__content-social">
            <a href="https://t.me/+79316242356" target="_blank"><SvgIcon icon="tg" /></a>
            <!--            <a href="https://t.me/+79316242356" target="_blank"><SvgIcon icon="wa" /></a> -->
            <a href="https://apps.apple.com/by/app/inflowstore/id6444021117" target="_blank"><SvgIcon icon="android" /></a>
            <a href="https://play.google.com/store/apps/details?id=ru.swc.inflow.store" target="_blank"><SvgIcon icon="apple" /></a>
          </div>
          <a v-if="mainStore.isMobile" href="https://softwarecenter.ru/" target="_blank" class="footer__content-info">
            <p>Разработчик<br><b>"Центр Программного Обеспечения"</b></p>
            <p><b>"Лучший разработчик программного обеспечения в России по версии Сбера"</b></p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="./AppFooter.ts">
</script>

<style lang="scss" src="./AppFooter.scss"></style>
